import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, inject, Input, OnInit, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { CheckboxValue } from 'app/shared/enums/checkbox-value.enum';
import { TotalsSidebarState } from '@manage-ceg/types/manage-ceg-page.types';
import { slideFromRightColumnAnimations } from '@manage-ceg/constants/manage-ceg-page.constants';
import { ManageTableCegRowBaseComponent } from '@manage-ceg/components/manage-table-ceg/components/manage-table-ceg-row-base';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { BudgetSummaryBarHelpers } from '@shared/components/budget-summary-bar/budget-summary-bar.helpers';
import { Configuration } from 'app/app.constants';
import { CustomAvailableBudgetConfigurationFormulaBuilderComponent } from '@manage-ceg/components/custom-available-budget-formula/cab-configuration-formula-builder.component';
import { CustomAvailableBudgetConfigurationService } from 'app/custom-available-budget/custom-available-budget-configuration.service';
import { Subject, takeUntil } from 'rxjs';
import { TableColumnId } from '@manage-ceg/components/manage-ceg-table-container/manage-ceg-table-container.enum';
import { BudgetDataService } from 'app/dashboard/budget-data/budget-data.service';


@Component({
  selector: '[manage-table-ceg-head-row]',
  templateUrl: './manage-table-ceg-head-row.component.html',
  styleUrls: ['./manage-table-ceg-head-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    slideFromRightColumnAnimations,
  ],
})
export class ManageTableCegHeadRowComponent extends ManageTableCegRowBaseComponent implements OnInit {
  private readonly configuration = inject(Configuration);
  private readonly customAvailableBudgetConfigurationService = inject(CustomAvailableBudgetConfigurationService);
  private destroy$ = new Subject<void>();
  private readonly budgetDataService = inject(BudgetDataService);

  @Input() selectAllValue = CheckboxValue.NotActive;
  @Output() onSelectAllChanged = new EventEmitter<MatCheckboxChange>();
  @Output() totalsSidebarStateChanged = new EventEmitter<TotalsSidebarState>();

  @HostBinding('class.with-formula')
  @Input() withFormula: boolean = false;
  tooltipComponentRef = CustomAvailableBudgetConfigurationFormulaBuilderComponent;
  isCABEnabled = true;
  selectedFormulaItems = [];
  isCABFormulaModifiedOnManagePage = false; 
  public isBudgetAnchorForecast = (this.budgetDataService.selectedBudgetSnapshot?.anchor_field === TableColumnId.Forecast);


  public tooltipPosition: ConnectedPosition = {
    originX: 'center',
    originY: 'top',
    overlayX: 'center',
    overlayY: 'bottom',
    offsetY: -15
  };

  protected tooltipContext = BudgetSummaryBarHelpers.createTooltipsForManageBudgetDefinitions(this.configuration.managePageKnowledgeLink);

  protected handleSelectAllChange($event: MatCheckboxChange): void {
    this.onSelectAllChanged.emit($event);
  }

  ngOnInit(): void {
    
    this.customAvailableBudgetConfigurationService.budgetDefinedCABFormula$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((items) => {
      this.selectedFormulaItems = items.map((item) => item.name);
    });

    this.customAvailableBudgetConfigurationService.managePageCustomAvailableBudgetFormulaOverride$
    .pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.isCABFormulaModifiedOnManagePage = res
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
